import { OrderSubmitted } from '@/logic/services';
import { NotificationTag } from '@/logic/state';
import { dataStorage } from '@muvi/react-common';

export const storage = {
  user: dataStorage<any | null>('user'),
  guest: dataStorage<any | null>('guest'),
  booking: dataStorage<any | null>('booking'),
  pageStatus: dataStorage<any | null>('pageStatus'),
  order: dataStorage<any | null>('order'),
  language: dataStorage<string>('app-language-provider'),
  muviDeviceId: dataStorage<string>('muvi-device-id'),
  oneSignalUserType: dataStorage<NotificationTag>('oneSignalUserType'),
  orderAnalyticsSubmit: dataStorage<OrderSubmitted>('order-analytics-submit'),
};
